// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchResultItem_container__Y8MMv","link":"SearchResultItem_link__316w0"};